import apiService from '../apiService'
export const currencyController = configService => {
  const service = apiService(configService)
  return {
    getCurrency: () => {
      return service.get({
        url: 'cms/supplier/currency',
      })
    },
  }
}
